import React, { useState, useCallback, useEffect } from "react";
import {
  Layout,
  Card,
  FormLayout,
  TextField,
  Page,
  Toast,
  Text,
  PageActions,
  Loading,
  InlineError,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import NavigationLayout from "../Components/NavigationLayout";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const navigate = useNavigate();
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastMsg, setToastMsg] = useState("");
  const [isSaving, setIsSaving] = useState(true);
  const toastMarkup = active ? (
    <Toast content={toastMsg} onDismiss={toggleActive} />
  ) : null;
  const handleChangeFirstName = (newValue) => {
    setItem({ ...item, firstName: newValue });
  };
  const handleChangeLastName = useCallback((newValue) => {
    setItem({ ...item, lastName: newValue });
  }, []);

  const handleChangeEmailValue = (newValue) => {
    setItem({ ...item, email: newValue });
  };
  const handleChangeNewPasswordValue = useCallback((newValue) => {
    setNewPasswordValue(newValue);
    setPasswordsError("");
    setNewPasswordError("");
  }, []);
  const handleChangeConfirmPasswordValue = useCallback((newValue) => {
    setConfirmPasswordValue(newValue);
    setConfirmPasswordError("");
    setPasswordsError("");
  }, []);
  const [passwordsError, setPasswordsError] = useState("");
  const [item, setItem] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  useEffect(() => {
    axios
      .get("/profile")
      .then((result) => {
        console.log(result.data.data);
        setItem({
          firstName: result?.data?.data?.first_name
            ? result?.data?.data?.first_name
            : "",
          lastName: result?.data?.data?.last_name
            ? result?.data?.data?.last_name
            : "",
          email: result?.data?.data?.email ? result?.data?.data?.email : "",
        });
        setIsSaving(false);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <NavigationLayout>
      <Page>
        {isSaving ? <Loading /> : null}
        <Layout>
          <Layout.AnnotatedSection title="Account Information" description="">
            <Card>
              <Card.Section title="Details">
                <FormLayout>
                  <FormLayout.Group condensed>
                    <FormLayout>
                      <TextField
                        value={item.firstName}
                        label="First Name"
                        onChange={handleChangeFirstName}
                      />
                    </FormLayout>
                    <FormLayout>
                      <TextField
                        value={item.lastName}
                        label="Last Name"
                        onChange={handleChangeLastName}
                      />
                    </FormLayout>
                  </FormLayout.Group>
                  <TextField
                    value={item.email}
                    label="Email"
                    onChange={handleChangeEmailValue}
                    disabled
                  />
                </FormLayout>
              </Card.Section>

              <Card.Section title="Change Password">
                <FormLayout>
                  <Text>
                    {`Change the password you use to login to ${process.env.REACT_APP_CLIENT_NAME}`}
                  </Text>
                  <FormLayout>
                    <FormLayout.Group condensed>
                      <TextField
                        value={newPasswordValue}
                        label="New Password"
                        onChange={handleChangeNewPasswordValue}
                        error={newPasswordError}
                        helpText="Password must contain at least 6 characters"
                      />
                      <TextField
                        value={confirmPasswordValue}
                        label="Confirm Password"
                        onChange={handleChangeConfirmPasswordValue}
                        error={confirmPasswordError}
                      />
                    </FormLayout.Group>
                  </FormLayout>
                  <InlineError message={passwordsError} />
                </FormLayout>
              </Card.Section>
            </Card>
          </Layout.AnnotatedSection>
        </Layout>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    </NavigationLayout>
  );

  function handleSave() {
    if (
      newPasswordValue !== confirmPasswordValue ||
      (newPasswordValue.length < 6 && newPasswordValue)
    ) {
      newPasswordValue !== confirmPasswordValue &&
        setPasswordsError("Passwords do not match");
      newPasswordValue.length < 6 &&
        newPasswordValue &&
        setNewPasswordError("Passwords must be at least 6 characters");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.firstName && form_data.append("first_name", item.firstName);
      item.lastName && form_data.append("last_name", item.lastName);
      newPasswordValue && form_data.append("password", newPasswordValue);
      confirmPasswordValue &&
        form_data.append("confirm-password", confirmPasswordValue);
      form_data.append("_method", "PATCH");
      axios
        .post("/profile", form_data)
        .then((res) => {
          if (newPasswordValue) {
            navigate("/");
          } else {
            setToastMsg("Your profile has been updated successfully");
            toggleActive();
            setIsSaving(false);
          }
        })
        .catch(function (error) {
          // if (error.response) {
          //   error.response.status === 500 && setSetShowServerErrorToast(true);
          // }
        });
    }
  }
}
